
import SubscriptionCard_benefit from './SubscriptionCard_benefit';
import { useNavigate } from 'react-router-dom';

export default function SubscriptionCard({ subscription, header, isActive, priceValue }) {
    const nav = useNavigate();
    const deployBenefits=()=>{
        return subscription.map((benefit, inx)=>{
            return <SubscriptionCard_benefit key={`SubscriptionCard_benefit_${inx}`} header={benefit.header} icon={benefit.icon} list={benefit.list} status={benefit.status} isActive={isActive}/>
        });
    }
    const handleMoveToForm = ()=>{window.scrollTo({top: 0,behavior:"smooth"});nav("/webingo/owner-creation-form");}
    return (
        <div className="subscriptionCard" style={{filter:!isActive ? "brightness(80%)" : "none"}} data-aos="fade-up">
            {!isActive && <div className='subscriptionCard_unavailable'>בקרוב...</div>}
            <h1 className='subscriptionCard_mainHeader' style={{filter: !isActive ? "opacity(40%)" : "none"}}>{header}</h1>
            <h3 className='subscriptionCard_subHeader' style={{filter: !isActive ? "opacity(40%)" : "none"}}>בנה עסק משלך היום ונהל אותו ללא צורך בעלויות תחזוקה נוספות - וחסוך אלפי שקלים!</h3>
            {deployBenefits()}
            <h2 className='subscriptionCard_priceValue' style={{filter: !isActive ? "opacity(40%)" : "none"}}>עלות מנוי - {priceValue.toFixed(1)}₪</h2>
            <button className='subscribeBtn' disabled={!isActive} style={{filter: !isActive ? "opacity(40%)" : "none"}} onClick={()=>{return !isActive ? null : handleMoveToForm()}}>הצטרף עכשיו</button>
        </div>
    )
}
